export const immersionFacileContactEmail =
  "contact@immersion-facile.beta.gouv.fr";

export const immersionFacileNoReplyEmail =
  "ne-pas-ecrire-a-cet-email@immersion-facile.beta.gouv.fr";

export const immersionFacileNoReplyEmailSender = {
  name: "Immersion Facilitée",
  email: immersionFacileNoReplyEmail,
};

export const backOfficeEmail = "support@immersion-facile.beta.gouv.fr";

export const immersionFacileDelegationEmail =
  "delegation@immersion-facile.beta.gouv.fr";

export const discussionEmail = "mise-en-relation@immersion-facile.beta.gouv.fr";

export const discussionEmailSender = {
  name: "Immersion Facilitée",
  email: discussionEmail,
};

export const assesmentEmail = "bilan@immersion-facile.beta.gouv.fr";

export const assessmentEmailSender = {
  name: "Immersion Facilitée",
  email: assesmentEmail,
};
